import { apiRequest, request } from './index'

export const createBackupRequest = () =>
  apiRequest('/admin/backup', { method: 'POST' }, true)

export const listBackupsRequest = () =>
  apiRequest('/admin/backups', { method: 'GET' }, true)

export const deleteBackupRequest = (key) =>
  apiRequest('/admin/backups', { method: 'DELETE', body: JSON.stringify({ key }) }, true)

export const downloadBackupRequest = (key) =>
  request(`/admin/backups/download?key=${encodeURIComponent(key)}`, {
    method: 'GET',
    responseType: 'blob'
  })

export const restoreBackupRequest = (url, targetDatabase) =>
  apiRequest('/admin/backups/restore', {
    method: 'POST',
    body: JSON.stringify({ url, targetDatabase })
  }, true)
